import { render, staticRenderFns } from "./ACOS-rank.vue?vue&type=template&id=8081feda&scoped=true&"
import script from "./ACOS-rank.vue?vue&type=script&lang=js&"
export * from "./ACOS-rank.vue?vue&type=script&lang=js&"
import style0 from "./ACOS-rank.vue?vue&type=style&index=0&id=8081feda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8081feda",
  null
  
)

export default component.exports